if (!customElements.get('qg-room-look')) {
  customElements.define(
    'qg-room-look',
    class QgRoomLook extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', this.onClick.bind(this), { signal: this.controller.signal });
        this.addEventListener('focusin', this.onFocus.bind(this), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onClick(event) {
        const hotspot = event.target.closest('[data-qg-hotspot]');
        if (hotspot) this.activate(hotspot.dataset.qgHotspot);
      }

      onFocus(event) {
        const hotspot = event.target.closest('[data-qg-hotspot]');
        if (hotspot) this.activate(hotspot.dataset.qgHotspot);
      }

      activate(id) {
        this.querySelectorAll('[data-qg-hotspot]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item.dataset.qgHotspot === id));
        });
        this.querySelectorAll('[data-qg-room-product]').forEach((item) => {
          if (item.dataset.qgRoomProduct === id) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      }
    }
  );
}

